import useTitle from "../../../Hooks/useTitle";
import { Doughnut, Line } from "react-chartjs-2";
import {
  ArcElement,
  CategoryScale,
  Chart,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import {
  Await,
  Link,
  useLoaderData,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { Suspense, useState } from "react";
import { Space, DatePicker } from "antd";
import dayjs from "dayjs";
import { BiRefresh } from "react-icons/bi";
import { LoanProfitTable, LoanTable } from "../../../Components/Dashboard/LoanTransaction";
Chart.register(
  ArcElement,
  LinearScale,
  PointElement,
  LineController,
  CategoryScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const DashboardIndex = () => {
  useTitle("Dashboard");
  const data = useLoaderData();

  const [, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  function handleRefreshClick() {
    setLoading(true);
    setSearchParams({ refresh: true });
    setLoading(false);
  }
  // const navigate = useNavigate();

  const rangePresets = [
    {
      label: "Last 7 Days",
      value: [dayjs().add(-7, "d"), dayjs()],
    },
    {
      label: "Last 14 Days",
      value: [dayjs().add(-14, "d"), dayjs()],
    },
    {
      label: "Last 30 Days",
      value: [dayjs().add(-30, "d"), dayjs()],
    },
    {
      label: "Last 90 Days",
      value: [dayjs().add(-90, "d"), dayjs()],
    },
  ];

  return (
    <div className="flex h-full w-full flex-col items-start justify-start space-y-5 overflow-y-auto overflow-x-hidden pb-10">
      <div className="flex w-full flex-none items-end justify-between">
        <div className="flex w-full items-center gap-x-2">
          <h1 className="text-2xl font-bold">Dashboard</h1>
          <button
            disabled={loading}
            className="jusitfy-center flex h-9 items-center bg-purple-700 px-2 text-sm text-white"
            onClick={handleRefreshClick}
          >
            <BiRefresh
              size={32}
              className={`cursor-pointer ${loading ? "animate-spin" : ""}`}
            />
            <p>Refresh Capsa</p>
          </button>
          {/* <p className="text-            
          
[14px] font-[400] leading-[21px] text-gray-500">
            Hello <span>John Doe</span>, Here is your Business Performance
          </p> */}
        </div>
        <div>
          <Space direction="vertical" size={12}>
            <DatePicker.RangePicker
              presets={rangePresets}
              onChange={(dt, string) => {
                setSearchParams({ dateFrom: string[0], dateTo: string[1] });
              }}
            />
          </Space>
        </div>
      </div>
      <Suspense>
        <Await resolve={data?.data}>
          {(data) => {
            const statistics = data?.response?.data?.statistics;
            const waitingList = data?.waitingListData?.data;
            const capsa = data?.capsaData?.data;
            const cooperativeStat = data?.cooperativeStats?.data;
            const loanStat = data?.LoanStats?.data?.data;
            return (
              <div className="grid w-full flex-none grid-cols-1 divide-x divide-[#E7EAEE] overflow-hidden rounded-[24px] bg-white p-6 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5">
                <SinglePanel
                  description="Total Transaction Volume"
                  value={`${capsa?.totalTransactionVolume ?? 0}`}
                  isValue={true}
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="none"
                    >
                      <path
                        fill="#fff"
                        d="m2.682 5.077.73.372-.73-.372Zm.728-.729.372.73-.372-.73Zm0 11.303.372-.73-.372.73Zm-.728-.728-.731.373.73-.373Zm14.636 0-.73-.372.73.372Zm-.728.729-.372-.731.372.73Zm.729-10.575-.731.372.73-.372Zm-.73-.729.373-.73-.372.73ZM5.834 11.68a.82.82 0 0 0 0 1.64v-1.64Zm3.334 1.64a.82.82 0 1 0 0-1.64v1.64ZM2.5 8.346a.82.82 0 1 0 0 1.64v-1.64Zm15 1.64a.82.82 0 0 0 0-1.64v1.64ZM2.5 6.68a.82.82 0 1 0 0 1.64V6.68Zm15 1.64a.82.82 0 0 0 0-1.64v1.64Zm-.82-1.487v6.333h1.64V6.833h-1.64Zm-1.846 8.18H5.167v1.64h9.667v-1.64ZM3.32 13.166V6.833H1.68v6.333h1.64Zm1.847-8.18h9.666v-1.64H5.168v1.64ZM3.32 6.834c0-.48 0-.791.02-1.028.019-.227.05-.313.072-.356l-1.461-.745c-.16.313-.219.64-.246.968-.026.319-.025.708-.025 1.161h1.64Zm1.847-3.487c-.453 0-.843 0-1.162.026-.328.027-.654.086-.967.245l.744 1.462c.043-.022.13-.054.357-.072.237-.02.548-.02 1.028-.02v-1.64ZM3.412 5.45a.846.846 0 0 1 .37-.37l-.744-1.462c-.469.239-.849.62-1.087 1.087l1.461.745Zm1.755 9.564c-.48 0-.791 0-1.028-.02-.228-.018-.314-.05-.357-.072l-.744 1.461c.313.16.639.219.967.246.32.026.709.025 1.162.025v-1.64ZM1.68 13.166c0 .454 0 .843.025 1.162.027.329.086.654.246.968l1.461-.745c-.022-.043-.053-.13-.072-.357-.02-.236-.02-.547-.02-1.028H1.68Zm2.102 1.755a.846.846 0 0 1-.37-.37l-1.461.745c.238.467.618.848 1.087 1.086l.744-1.461Zm12.898-1.755c0 .48 0 .792-.02 1.028-.018.228-.05.314-.072.357l1.461.745c.16-.314.219-.64.246-.968.026-.32.025-.708.025-1.162h-1.64Zm-1.846 3.487c.453 0 .842 0 1.16-.025.33-.027.655-.086.968-.246l-.744-1.461c-.044.022-.13.054-.357.072-.237.02-.547.02-1.027.02v1.64Zm1.754-2.102a.847.847 0 0 1-.37.37l.744 1.461a2.487 2.487 0 0 0 1.087-1.087l-1.461-.744Zm1.732-7.718c0-.453 0-.842-.025-1.161-.027-.329-.086-.655-.246-.968l-1.461.745c.022.043.053.129.072.356.02.237.02.548.02 1.028h1.64Zm-3.486-1.846c.48 0 .79 0 1.027.02.227.018.313.05.357.072l.744-1.462c-.313-.16-.639-.218-.967-.245-.32-.026-.708-.026-1.161-.026v1.64Zm3.215-.283a2.487 2.487 0 0 0-1.087-1.087l-.744 1.462c.16.081.289.21.37.37l1.461-.745ZM5.833 13.32h3.334v-1.64H5.833v1.64ZM2.5 9.987h15v-1.64h-15v1.64Zm0-1.667h15V6.68h-15v1.64Z"
                      />
                    </svg>
                  }
                  color="#590DA4"
                />
                <SinglePanel
                  description="Total Transaction Value"
                  amount={` ${capsa?.totalTransactionValue ?? 0}`}
                  isValue={false}
                  icon={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.68166 5.07654L3.41237 5.44886L2.68166 5.07654ZM3.40983 4.34816L3.78215 5.07888L3.40983 4.34816ZM3.40983 15.6515L3.78215 14.9208L3.40983 15.6515ZM2.68166 14.9232L1.95094 15.2955L2.68166 14.9232ZM17.3185 14.9232L16.5878 14.5509L17.3185 14.9232ZM16.5898 15.6515L16.2175 14.9208L16.5898 15.6515ZM17.3185 5.07654L16.5878 5.44886V5.44886L17.3185 5.07654ZM16.5898 4.34816L16.9621 3.61744L16.5898 4.34816ZM5.83333 11.6797C5.3804 11.6797 5.01323 12.0469 5.01323 12.4998C5.01323 12.9528 5.3804 13.3199 5.83333 13.3199V11.6797ZM9.16667 13.3199C9.6196 13.3199 9.98677 12.9528 9.98677 12.4998C9.98677 12.0469 9.6196 11.6797 9.16667 11.6797V13.3199ZM2.5 8.3464C2.04707 8.3464 1.6799 8.71357 1.6799 9.1665C1.6799 9.61943 2.04707 9.98661 2.5 9.98661V8.3464ZM17.5 9.98661C17.9529 9.98661 18.3201 9.61943 18.3201 9.1665C18.3201 8.71357 17.9529 8.3464 17.5 8.3464V9.98661ZM2.5 6.67974C2.04707 6.67974 1.6799 7.04691 1.6799 7.49984C1.6799 7.95277 2.04707 8.31994 2.5 8.31994V6.67974ZM17.5 8.31994C17.9529 8.31994 18.3201 7.95277 18.3201 7.49984C18.3201 7.04691 17.9529 6.67974 17.5 6.67974V8.31994ZM16.6799 6.83313V13.1665H18.3201V6.83313H16.6799ZM14.8335 15.0131H5.16683V16.6533H14.8335V15.0131ZM3.3201 13.1665V6.83313H1.6799V13.1665H3.3201ZM5.16683 4.98661H14.8335V3.3464H5.16683V4.98661ZM3.3201 6.83313C3.3201 6.35289 3.32074 6.04204 3.34008 5.80528C3.35865 5.5781 3.39026 5.49224 3.41237 5.44886L1.95094 4.70422C1.79139 5.01735 1.73218 5.34308 1.70533 5.67171C1.67926 5.99076 1.6799 6.37995 1.6799 6.83313H3.3201ZM5.16683 3.3464C4.71364 3.3464 4.32437 3.34576 4.00523 3.37183C3.67657 3.39867 3.3507 3.45787 3.03751 3.61744L3.78215 5.07888C3.82548 5.0568 3.9114 5.02516 4.13875 5.00659C4.37563 4.98724 4.68659 4.98661 5.16683 4.98661V3.3464ZM3.41237 5.44886C3.49364 5.28935 3.62307 5.15993 3.78215 5.07888L3.03751 3.61744C2.56938 3.85597 2.18925 4.23652 1.95094 4.70422L3.41237 5.44886ZM5.16683 15.0131C4.68661 15.0131 4.37564 15.0124 4.13877 14.9931C3.91142 14.9745 3.82549 14.9429 3.78215 14.9208L3.03751 16.3822C3.35069 16.5418 3.67655 16.601 4.00521 16.6278C4.32435 16.6539 4.71363 16.6533 5.16683 16.6533V15.0131ZM1.6799 13.1665C1.6799 13.6196 1.67926 14.0089 1.70533 14.3279C1.73218 14.6566 1.79138 14.9824 1.95094 15.2955L3.41237 14.5509C3.39027 14.5075 3.35865 14.4216 3.34009 14.1944C3.32074 13.9576 3.3201 13.6467 3.3201 13.1665H1.6799ZM3.78215 14.9208C3.62298 14.8397 3.4936 14.7103 3.41237 14.5509L1.95094 15.2955C2.18929 15.7633 2.56947 16.1437 3.03751 16.3822L3.78215 14.9208ZM16.6799 13.1665C16.6799 13.6468 16.6793 13.9577 16.66 14.1945C16.6415 14.4218 16.6099 14.5076 16.5878 14.5509L18.0492 15.2955C18.2088 14.9823 18.268 14.6564 18.2948 14.3278C18.3208 14.0088 18.3201 13.6196 18.3201 13.1665H16.6799ZM14.8335 16.6533C15.2867 16.6533 15.6758 16.6539 15.9948 16.6278C16.3234 16.601 16.6491 16.5417 16.9621 16.3822L16.2175 14.9208C16.1741 14.9429 16.0882 14.9745 15.8612 14.9931C15.6245 15.0124 15.3137 15.0131 14.8335 15.0131V16.6533ZM16.5878 14.5509C16.5069 14.7097 16.3772 14.8394 16.2175 14.9208L16.9621 16.3822C17.4296 16.144 17.8106 15.7639 18.0492 15.2955L16.5878 14.5509ZM18.3201 6.83313C18.3201 6.38004 18.3208 5.99084 18.2948 5.67184C18.268 5.34325 18.2088 5.01744 18.0492 4.70422L16.5878 5.44886C16.6099 5.49215 16.6415 5.57793 16.66 5.80515C16.6793 6.04197 16.6799 6.3528 16.6799 6.83313H18.3201ZM14.8335 4.98661C15.3137 4.98661 15.6245 4.98724 15.8612 5.00659C16.0883 5.02514 16.1741 5.05675 16.2175 5.07888L16.9621 3.61744C16.649 3.45791 16.3234 3.39869 15.9948 3.37183C15.6758 3.34576 15.2867 3.3464 14.8335 3.3464V4.98661ZM18.0492 4.70422C17.8107 4.23597 17.4297 3.85569 16.9621 3.61744L16.2175 5.07888C16.3771 5.16021 16.5068 5.2899 16.5878 5.44886L18.0492 4.70422ZM5.83333 13.3199H9.16667V11.6797H5.83333V13.3199ZM2.5 9.98661H17.5V8.3464H2.5V9.98661ZM2.5 8.31994H17.5V6.67974H2.5V8.31994Z"
                        fill="white"
                      />
                    </svg>
                  }
                  color="#88C02C"
                />
                <SinglePanel
                  description="Total Transaction Returns"
                  amount={` ${capsa?.totalTransactionReturns ?? 0}`}
                  isValue={false}
                  icon={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.68166 5.07654L3.41237 5.44886L2.68166 5.07654ZM3.40983 4.34816L3.78215 5.07888L3.40983 4.34816ZM3.40983 15.6515L3.78215 14.9208L3.40983 15.6515ZM2.68166 14.9232L1.95094 15.2955L2.68166 14.9232ZM17.3185 14.9232L16.5878 14.5509L17.3185 14.9232ZM16.5898 15.6515L16.2175 14.9208L16.5898 15.6515ZM17.3185 5.07654L16.5878 5.44886V5.44886L17.3185 5.07654ZM16.5898 4.34816L16.9621 3.61744L16.5898 4.34816ZM5.83333 11.6797C5.3804 11.6797 5.01323 12.0469 5.01323 12.4998C5.01323 12.9528 5.3804 13.3199 5.83333 13.3199V11.6797ZM9.16667 13.3199C9.6196 13.3199 9.98677 12.9528 9.98677 12.4998C9.98677 12.0469 9.6196 11.6797 9.16667 11.6797V13.3199ZM2.5 8.3464C2.04707 8.3464 1.6799 8.71357 1.6799 9.1665C1.6799 9.61943 2.04707 9.98661 2.5 9.98661V8.3464ZM17.5 9.98661C17.9529 9.98661 18.3201 9.61943 18.3201 9.1665C18.3201 8.71357 17.9529 8.3464 17.5 8.3464V9.98661ZM2.5 6.67974C2.04707 6.67974 1.6799 7.04691 1.6799 7.49984C1.6799 7.95277 2.04707 8.31994 2.5 8.31994V6.67974ZM17.5 8.31994C17.9529 8.31994 18.3201 7.95277 18.3201 7.49984C18.3201 7.04691 17.9529 6.67974 17.5 6.67974V8.31994ZM16.6799 6.83313V13.1665H18.3201V6.83313H16.6799ZM14.8335 15.0131H5.16683V16.6533H14.8335V15.0131ZM3.3201 13.1665V6.83313H1.6799V13.1665H3.3201ZM5.16683 4.98661H14.8335V3.3464H5.16683V4.98661ZM3.3201 6.83313C3.3201 6.35289 3.32074 6.04204 3.34008 5.80528C3.35865 5.5781 3.39026 5.49224 3.41237 5.44886L1.95094 4.70422C1.79139 5.01735 1.73218 5.34308 1.70533 5.67171C1.67926 5.99076 1.6799 6.37995 1.6799 6.83313H3.3201ZM5.16683 3.3464C4.71364 3.3464 4.32437 3.34576 4.00523 3.37183C3.67657 3.39867 3.3507 3.45787 3.03751 3.61744L3.78215 5.07888C3.82548 5.0568 3.9114 5.02516 4.13875 5.00659C4.37563 4.98724 4.68659 4.98661 5.16683 4.98661V3.3464ZM3.41237 5.44886C3.49364 5.28935 3.62307 5.15993 3.78215 5.07888L3.03751 3.61744C2.56938 3.85597 2.18925 4.23652 1.95094 4.70422L3.41237 5.44886ZM5.16683 15.0131C4.68661 15.0131 4.37564 15.0124 4.13877 14.9931C3.91142 14.9745 3.82549 14.9429 3.78215 14.9208L3.03751 16.3822C3.35069 16.5418 3.67655 16.601 4.00521 16.6278C4.32435 16.6539 4.71363 16.6533 5.16683 16.6533V15.0131ZM1.6799 13.1665C1.6799 13.6196 1.67926 14.0089 1.70533 14.3279C1.73218 14.6566 1.79138 14.9824 1.95094 15.2955L3.41237 14.5509C3.39027 14.5075 3.35865 14.4216 3.34009 14.1944C3.32074 13.9576 3.3201 13.6467 3.3201 13.1665H1.6799ZM3.78215 14.9208C3.62298 14.8397 3.4936 14.7103 3.41237 14.5509L1.95094 15.2955C2.18929 15.7633 2.56947 16.1437 3.03751 16.3822L3.78215 14.9208ZM16.6799 13.1665C16.6799 13.6468 16.6793 13.9577 16.66 14.1945C16.6415 14.4218 16.6099 14.5076 16.5878 14.5509L18.0492 15.2955C18.2088 14.9823 18.268 14.6564 18.2948 14.3278C18.3208 14.0088 18.3201 13.6196 18.3201 13.1665H16.6799ZM14.8335 16.6533C15.2867 16.6533 15.6758 16.6539 15.9948 16.6278C16.3234 16.601 16.6491 16.5417 16.9621 16.3822L16.2175 14.9208C16.1741 14.9429 16.0882 14.9745 15.8612 14.9931C15.6245 15.0124 15.3137 15.0131 14.8335 15.0131V16.6533ZM16.5878 14.5509C16.5069 14.7097 16.3772 14.8394 16.2175 14.9208L16.9621 16.3822C17.4296 16.144 17.8106 15.7639 18.0492 15.2955L16.5878 14.5509ZM18.3201 6.83313C18.3201 6.38004 18.3208 5.99084 18.2948 5.67184C18.268 5.34325 18.2088 5.01744 18.0492 4.70422L16.5878 5.44886C16.6099 5.49215 16.6415 5.57793 16.66 5.80515C16.6793 6.04197 16.6799 6.3528 16.6799 6.83313H18.3201ZM14.8335 4.98661C15.3137 4.98661 15.6245 4.98724 15.8612 5.00659C16.0883 5.02514 16.1741 5.05675 16.2175 5.07888L16.9621 3.61744C16.649 3.45791 16.3234 3.39869 15.9948 3.37183C15.6758 3.34576 15.2867 3.3464 14.8335 3.3464V4.98661ZM18.0492 4.70422C17.8107 4.23597 17.4297 3.85569 16.9621 3.61744L16.2175 5.07888C16.3771 5.16021 16.5068 5.2899 16.5878 5.44886L18.0492 4.70422ZM5.83333 13.3199H9.16667V11.6797H5.83333V13.3199ZM2.5 9.98661H17.5V8.3464H2.5V9.98661ZM2.5 8.31994H17.5V6.67974H2.5V8.31994Z"
                        fill="white"
                      />
                    </svg>
                  }
                  color="#88C02C"
                />
                <SinglePanel
                  description="Total Tenure"
                  value={`${capsa?.totalTenure ?? 0}`}
                  isValue={true}
                  icon={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.1667 16.6665C14.1667 15.2858 12.3012 14.1665 10 14.1665C7.69881 14.1665 5.83333 15.2858 5.83333 16.6665M17.5 14.1664C17.5 13.1412 16.4716 12.2602 15 11.8744M2.5 14.1664C2.5 13.1412 3.52841 12.2602 5 11.8744M15 8.52993C15.5115 8.07216 15.8333 7.40692 15.8333 6.6665C15.8333 5.28579 14.714 4.1665 13.3333 4.1665C12.693 4.1665 12.109 4.40722 11.6667 4.80308M5 8.52993C4.48854 8.07216 4.16667 7.40692 4.16667 6.6665C4.16667 5.28579 5.28595 4.1665 6.66667 4.1665C7.30696 4.1665 7.89104 4.40722 8.33333 4.80308M10 11.6665C8.61929 11.6665 7.5 10.5472 7.5 9.1665C7.5 7.78579 8.61929 6.6665 10 6.6665C11.3807 6.6665 12.5 7.78579 12.5 9.1665C12.5 10.5472 11.3807 11.6665 10 11.6665Z"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  color="#F59E0B"
                />
                <SinglePanel
                  description="Customers"
                  value={cooperativeStat?.totalUsers}
                  isValue={true}
                  icon={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.1667 16.6665C14.1667 15.2858 12.3012 14.1665 10 14.1665C7.69881 14.1665 5.83333 15.2858 5.83333 16.6665M17.5 14.1664C17.5 13.1412 16.4716 12.2602 15 11.8744M2.5 14.1664C2.5 13.1412 3.52841 12.2602 5 11.8744M15 8.52993C15.5115 8.07216 15.8333 7.40692 15.8333 6.6665C15.8333 5.28579 14.714 4.1665 13.3333 4.1665C12.693 4.1665 12.109 4.40722 11.6667 4.80308M5 8.52993C4.48854 8.07216 4.16667 7.40692 4.16667 6.6665C4.16667 5.28579 5.28595 4.1665 6.66667 4.1665C7.30696 4.1665 7.89104 4.40722 8.33333 4.80308M10 11.6665C8.61929 11.6665 7.5 10.5472 7.5 9.1665C7.5 7.78579 8.61929 6.6665 10 6.6665C11.3807 6.6665 12.5 7.78579 12.5 9.1665C12.5 10.5472 11.3807 11.6665 10 11.6665Z"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  color="#F59E0B"
                />
                <SinglePanel
                  description="Companies"
                  value={cooperativeStat?.totalCompanies}
                  isValue={true}
                  icon={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.6665 16.6667H18.3332M5.83317 8.33333H9.1665M11.6665 16.6667H16.6665V10C16.6665 9.22343 16.6664 8.83513 16.5396 8.52885C16.3704 8.12047 16.046 7.79602 15.6376 7.62687C15.3314 7.5 14.9433 7.5 14.1667 7.5C13.3901 7.5 13.0018 7.5 12.6956 7.62687C12.2872 7.79602 11.9625 8.12047 11.7934 8.52885C11.6665 8.83513 11.6665 9.22343 11.6665 10V16.6667ZM11.6665 16.6667V5.16663C11.6665 4.23321 11.6667 3.76655 11.485 3.41003C11.3252 3.09643 11.0699 2.84144 10.7563 2.68166C10.3998 2.5 9.93342 2.5 9 2.5H6C5.06658 2.5 4.59952 2.5 4.243 2.68166C3.9294 2.84144 3.67462 3.09643 3.51483 3.41003C3.33317 3.76655 3.33317 4.23321 3.33317 5.16663V16.6667H11.6665ZM5.83317 5.83333L9.1665 5.83333"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  color="#0D0F11"
                />

                <SinglePanel
                  description="Waiting List"
                  value={waitingList}
                  isValue={true}
                  icon={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.6665 16.6667H18.3332M5.83317 8.33333H9.1665M11.6665 16.6667H16.6665V10C16.6665 9.22343 16.6664 8.83513 16.5396 8.52885C16.3704 8.12047 16.046 7.79602 15.6376 7.62687C15.3314 7.5 14.9433 7.5 14.1667 7.5C13.3901 7.5 13.0018 7.5 12.6956 7.62687C12.2872 7.79602 11.9625 8.12047 11.7934 8.52885C11.6665 8.83513 11.6665 9.22343 11.6665 10V16.6667ZM11.6665 16.6667V5.16663C11.6665 4.23321 11.6667 3.76655 11.485 3.41003C11.3252 3.09643 11.0699 2.84144 10.7563 2.68166C10.3998 2.5 9.93342 2.5 9 2.5H6C5.06658 2.5 4.59952 2.5 4.243 2.68166C3.9294 2.84144 3.67462 3.09643 3.51483 3.41003C3.33317 3.76655 3.33317 4.23321 3.33317 5.16663V16.6667H11.6665ZM5.83317 5.83333L9.1665 5.83333"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  color="#0D0F11"
                />

                <SinglePanel
                  description="Total Customer Wallet"
                  amount={` ${cooperativeStat.totalCustomerWallet}`}
                  isValue={false}
                  icon={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.68166 5.07654L3.41237 5.44886L2.68166 5.07654ZM3.40983 4.34816L3.78215 5.07888L3.40983 4.34816ZM3.40983 15.6515L3.78215 14.9208L3.40983 15.6515ZM2.68166 14.9232L1.95094 15.2955L2.68166 14.9232ZM17.3185 14.9232L16.5878 14.5509L17.3185 14.9232ZM16.5898 15.6515L16.2175 14.9208L16.5898 15.6515ZM17.3185 5.07654L16.5878 5.44886V5.44886L17.3185 5.07654ZM16.5898 4.34816L16.9621 3.61744L16.5898 4.34816ZM5.83333 11.6797C5.3804 11.6797 5.01323 12.0469 5.01323 12.4998C5.01323 12.9528 5.3804 13.3199 5.83333 13.3199V11.6797ZM9.16667 13.3199C9.6196 13.3199 9.98677 12.9528 9.98677 12.4998C9.98677 12.0469 9.6196 11.6797 9.16667 11.6797V13.3199ZM2.5 8.3464C2.04707 8.3464 1.6799 8.71357 1.6799 9.1665C1.6799 9.61943 2.04707 9.98661 2.5 9.98661V8.3464ZM17.5 9.98661C17.9529 9.98661 18.3201 9.61943 18.3201 9.1665C18.3201 8.71357 17.9529 8.3464 17.5 8.3464V9.98661ZM2.5 6.67974C2.04707 6.67974 1.6799 7.04691 1.6799 7.49984C1.6799 7.95277 2.04707 8.31994 2.5 8.31994V6.67974ZM17.5 8.31994C17.9529 8.31994 18.3201 7.95277 18.3201 7.49984C18.3201 7.04691 17.9529 6.67974 17.5 6.67974V8.31994ZM16.6799 6.83313V13.1665H18.3201V6.83313H16.6799ZM14.8335 15.0131H5.16683V16.6533H14.8335V15.0131ZM3.3201 13.1665V6.83313H1.6799V13.1665H3.3201ZM5.16683 4.98661H14.8335V3.3464H5.16683V4.98661ZM3.3201 6.83313C3.3201 6.35289 3.32074 6.04204 3.34008 5.80528C3.35865 5.5781 3.39026 5.49224 3.41237 5.44886L1.95094 4.70422C1.79139 5.01735 1.73218 5.34308 1.70533 5.67171C1.67926 5.99076 1.6799 6.37995 1.6799 6.83313H3.3201ZM5.16683 3.3464C4.71364 3.3464 4.32437 3.34576 4.00523 3.37183C3.67657 3.39867 3.3507 3.45787 3.03751 3.61744L3.78215 5.07888C3.82548 5.0568 3.9114 5.02516 4.13875 5.00659C4.37563 4.98724 4.68659 4.98661 5.16683 4.98661V3.3464ZM3.41237 5.44886C3.49364 5.28935 3.62307 5.15993 3.78215 5.07888L3.03751 3.61744C2.56938 3.85597 2.18925 4.23652 1.95094 4.70422L3.41237 5.44886ZM5.16683 15.0131C4.68661 15.0131 4.37564 15.0124 4.13877 14.9931C3.91142 14.9745 3.82549 14.9429 3.78215 14.9208L3.03751 16.3822C3.35069 16.5418 3.67655 16.601 4.00521 16.6278C4.32435 16.6539 4.71363 16.6533 5.16683 16.6533V15.0131ZM1.6799 13.1665C1.6799 13.6196 1.67926 14.0089 1.70533 14.3279C1.73218 14.6566 1.79138 14.9824 1.95094 15.2955L3.41237 14.5509C3.39027 14.5075 3.35865 14.4216 3.34009 14.1944C3.32074 13.9576 3.3201 13.6467 3.3201 13.1665H1.6799ZM3.78215 14.9208C3.62298 14.8397 3.4936 14.7103 3.41237 14.5509L1.95094 15.2955C2.18929 15.7633 2.56947 16.1437 3.03751 16.3822L3.78215 14.9208ZM16.6799 13.1665C16.6799 13.6468 16.6793 13.9577 16.66 14.1945C16.6415 14.4218 16.6099 14.5076 16.5878 14.5509L18.0492 15.2955C18.2088 14.9823 18.268 14.6564 18.2948 14.3278C18.3208 14.0088 18.3201 13.6196 18.3201 13.1665H16.6799ZM14.8335 16.6533C15.2867 16.6533 15.6758 16.6539 15.9948 16.6278C16.3234 16.601 16.6491 16.5417 16.9621 16.3822L16.2175 14.9208C16.1741 14.9429 16.0882 14.9745 15.8612 14.9931C15.6245 15.0124 15.3137 15.0131 14.8335 15.0131V16.6533ZM16.5878 14.5509C16.5069 14.7097 16.3772 14.8394 16.2175 14.9208L16.9621 16.3822C17.4296 16.144 17.8106 15.7639 18.0492 15.2955L16.5878 14.5509ZM18.3201 6.83313C18.3201 6.38004 18.3208 5.99084 18.2948 5.67184C18.268 5.34325 18.2088 5.01744 18.0492 4.70422L16.5878 5.44886C16.6099 5.49215 16.6415 5.57793 16.66 5.80515C16.6793 6.04197 16.6799 6.3528 16.6799 6.83313H18.3201ZM14.8335 4.98661C15.3137 4.98661 15.6245 4.98724 15.8612 5.00659C16.0883 5.02514 16.1741 5.05675 16.2175 5.07888L16.9621 3.61744C16.649 3.45791 16.3234 3.39869 15.9948 3.37183C15.6758 3.34576 15.2867 3.3464 14.8335 3.3464V4.98661ZM18.0492 4.70422C17.8107 4.23597 17.4297 3.85569 16.9621 3.61744L16.2175 5.07888C16.3771 5.16021 16.5068 5.2899 16.5878 5.44886L18.0492 4.70422ZM5.83333 13.3199H9.16667V11.6797H5.83333V13.3199ZM2.5 9.98661H17.5V8.3464H2.5V9.98661ZM2.5 8.31994H17.5V6.67974H2.5V8.31994Z"
                        fill="white"
                      />
                    </svg>
                  }
                  color="#88C02C"
                />
                <SinglePanel
                  description="Subscribed Save and Pack Members"
                  value={cooperativeStat?.subscribedSaveandPackMembers}
                  isValue={true}
                  icon={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.1667 16.6665C14.1667 15.2858 12.3012 14.1665 10 14.1665C7.69881 14.1665 5.83333 15.2858 5.83333 16.6665M17.5 14.1664C17.5 13.1412 16.4716 12.2602 15 11.8744M2.5 14.1664C2.5 13.1412 3.52841 12.2602 5 11.8744M15 8.52993C15.5115 8.07216 15.8333 7.40692 15.8333 6.6665C15.8333 5.28579 14.714 4.1665 13.3333 4.1665C12.693 4.1665 12.109 4.40722 11.6667 4.80308M5 8.52993C4.48854 8.07216 4.16667 7.40692 4.16667 6.6665C4.16667 5.28579 5.28595 4.1665 6.66667 4.1665C7.30696 4.1665 7.89104 4.40722 8.33333 4.80308M10 11.6665C8.61929 11.6665 7.5 10.5472 7.5 9.1665C7.5 7.78579 8.61929 6.6665 10 6.6665C11.3807 6.6665 12.5 7.78579 12.5 9.1665C12.5 10.5472 11.3807 11.6665 10 11.6665Z"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  color="#F59E0B"
                />
                <SinglePanel
                  description="Vertified Users"
                  value={cooperativeStat?.verifiedUsers}
                  isValue={true}
                  icon={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.1667 16.6665C14.1667 15.2858 12.3012 14.1665 10 14.1665C7.69881 14.1665 5.83333 15.2858 5.83333 16.6665M17.5 14.1664C17.5 13.1412 16.4716 12.2602 15 11.8744M2.5 14.1664C2.5 13.1412 3.52841 12.2602 5 11.8744M15 8.52993C15.5115 8.07216 15.8333 7.40692 15.8333 6.6665C15.8333 5.28579 14.714 4.1665 13.3333 4.1665C12.693 4.1665 12.109 4.40722 11.6667 4.80308M5 8.52993C4.48854 8.07216 4.16667 7.40692 4.16667 6.6665C4.16667 5.28579 5.28595 4.1665 6.66667 4.1665C7.30696 4.1665 7.89104 4.40722 8.33333 4.80308M10 11.6665C8.61929 11.6665 7.5 10.5472 7.5 9.1665C7.5 7.78579 8.61929 6.6665 10 6.6665C11.3807 6.6665 12.5 7.78579 12.5 9.1665C12.5 10.5472 11.3807 11.6665 10 11.6665Z"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  color="#F59E0B"
                />

                <SinglePanel
                  description="Save and Go Members"
                  value={` ${cooperativeStat.saveAndGoMembers}`}
                  isValue={true}
                  icon={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.68166 5.07654L3.41237 5.44886L2.68166 5.07654ZM3.40983 4.34816L3.78215 5.07888L3.40983 4.34816ZM3.40983 15.6515L3.78215 14.9208L3.40983 15.6515ZM2.68166 14.9232L1.95094 15.2955L2.68166 14.9232ZM17.3185 14.9232L16.5878 14.5509L17.3185 14.9232ZM16.5898 15.6515L16.2175 14.9208L16.5898 15.6515ZM17.3185 5.07654L16.5878 5.44886V5.44886L17.3185 5.07654ZM16.5898 4.34816L16.9621 3.61744L16.5898 4.34816ZM5.83333 11.6797C5.3804 11.6797 5.01323 12.0469 5.01323 12.4998C5.01323 12.9528 5.3804 13.3199 5.83333 13.3199V11.6797ZM9.16667 13.3199C9.6196 13.3199 9.98677 12.9528 9.98677 12.4998C9.98677 12.0469 9.6196 11.6797 9.16667 11.6797V13.3199ZM2.5 8.3464C2.04707 8.3464 1.6799 8.71357 1.6799 9.1665C1.6799 9.61943 2.04707 9.98661 2.5 9.98661V8.3464ZM17.5 9.98661C17.9529 9.98661 18.3201 9.61943 18.3201 9.1665C18.3201 8.71357 17.9529 8.3464 17.5 8.3464V9.98661ZM2.5 6.67974C2.04707 6.67974 1.6799 7.04691 1.6799 7.49984C1.6799 7.95277 2.04707 8.31994 2.5 8.31994V6.67974ZM17.5 8.31994C17.9529 8.31994 18.3201 7.95277 18.3201 7.49984C18.3201 7.04691 17.9529 6.67974 17.5 6.67974V8.31994ZM16.6799 6.83313V13.1665H18.3201V6.83313H16.6799ZM14.8335 15.0131H5.16683V16.6533H14.8335V15.0131ZM3.3201 13.1665V6.83313H1.6799V13.1665H3.3201ZM5.16683 4.98661H14.8335V3.3464H5.16683V4.98661ZM3.3201 6.83313C3.3201 6.35289 3.32074 6.04204 3.34008 5.80528C3.35865 5.5781 3.39026 5.49224 3.41237 5.44886L1.95094 4.70422C1.79139 5.01735 1.73218 5.34308 1.70533 5.67171C1.67926 5.99076 1.6799 6.37995 1.6799 6.83313H3.3201ZM5.16683 3.3464C4.71364 3.3464 4.32437 3.34576 4.00523 3.37183C3.67657 3.39867 3.3507 3.45787 3.03751 3.61744L3.78215 5.07888C3.82548 5.0568 3.9114 5.02516 4.13875 5.00659C4.37563 4.98724 4.68659 4.98661 5.16683 4.98661V3.3464ZM3.41237 5.44886C3.49364 5.28935 3.62307 5.15993 3.78215 5.07888L3.03751 3.61744C2.56938 3.85597 2.18925 4.23652 1.95094 4.70422L3.41237 5.44886ZM5.16683 15.0131C4.68661 15.0131 4.37564 15.0124 4.13877 14.9931C3.91142 14.9745 3.82549 14.9429 3.78215 14.9208L3.03751 16.3822C3.35069 16.5418 3.67655 16.601 4.00521 16.6278C4.32435 16.6539 4.71363 16.6533 5.16683 16.6533V15.0131ZM1.6799 13.1665C1.6799 13.6196 1.67926 14.0089 1.70533 14.3279C1.73218 14.6566 1.79138 14.9824 1.95094 15.2955L3.41237 14.5509C3.39027 14.5075 3.35865 14.4216 3.34009 14.1944C3.32074 13.9576 3.3201 13.6467 3.3201 13.1665H1.6799ZM3.78215 14.9208C3.62298 14.8397 3.4936 14.7103 3.41237 14.5509L1.95094 15.2955C2.18929 15.7633 2.56947 16.1437 3.03751 16.3822L3.78215 14.9208ZM16.6799 13.1665C16.6799 13.6468 16.6793 13.9577 16.66 14.1945C16.6415 14.4218 16.6099 14.5076 16.5878 14.5509L18.0492 15.2955C18.2088 14.9823 18.268 14.6564 18.2948 14.3278C18.3208 14.0088 18.3201 13.6196 18.3201 13.1665H16.6799ZM14.8335 16.6533C15.2867 16.6533 15.6758 16.6539 15.9948 16.6278C16.3234 16.601 16.6491 16.5417 16.9621 16.3822L16.2175 14.9208C16.1741 14.9429 16.0882 14.9745 15.8612 14.9931C15.6245 15.0124 15.3137 15.0131 14.8335 15.0131V16.6533ZM16.5878 14.5509C16.5069 14.7097 16.3772 14.8394 16.2175 14.9208L16.9621 16.3822C17.4296 16.144 17.8106 15.7639 18.0492 15.2955L16.5878 14.5509ZM18.3201 6.83313C18.3201 6.38004 18.3208 5.99084 18.2948 5.67184C18.268 5.34325 18.2088 5.01744 18.0492 4.70422L16.5878 5.44886C16.6099 5.49215 16.6415 5.57793 16.66 5.80515C16.6793 6.04197 16.6799 6.3528 16.6799 6.83313H18.3201ZM14.8335 4.98661C15.3137 4.98661 15.6245 4.98724 15.8612 5.00659C16.0883 5.02514 16.1741 5.05675 16.2175 5.07888L16.9621 3.61744C16.649 3.45791 16.3234 3.39869 15.9948 3.37183C15.6758 3.34576 15.2867 3.3464 14.8335 3.3464V4.98661ZM18.0492 4.70422C17.8107 4.23597 17.4297 3.85569 16.9621 3.61744L16.2175 5.07888C16.3771 5.16021 16.5068 5.2899 16.5878 5.44886L18.0492 4.70422ZM5.83333 13.3199H9.16667V11.6797H5.83333V13.3199ZM2.5 9.98661H17.5V8.3464H2.5V9.98661ZM2.5 8.31994H17.5V6.67974H2.5V8.31994Z"
                        fill="white"
                      />
                    </svg>
                  }
                  color="#88C02C"
                />
                <SinglePanel
                  description="Save and Go Total Amount"
                  amount={` ${cooperativeStat.saveAndGoTotalAmount}`}
                  isValue={false}
                  icon={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.68166 5.07654L3.41237 5.44886L2.68166 5.07654ZM3.40983 4.34816L3.78215 5.07888L3.40983 4.34816ZM3.40983 15.6515L3.78215 14.9208L3.40983 15.6515ZM2.68166 14.9232L1.95094 15.2955L2.68166 14.9232ZM17.3185 14.9232L16.5878 14.5509L17.3185 14.9232ZM16.5898 15.6515L16.2175 14.9208L16.5898 15.6515ZM17.3185 5.07654L16.5878 5.44886V5.44886L17.3185 5.07654ZM16.5898 4.34816L16.9621 3.61744L16.5898 4.34816ZM5.83333 11.6797C5.3804 11.6797 5.01323 12.0469 5.01323 12.4998C5.01323 12.9528 5.3804 13.3199 5.83333 13.3199V11.6797ZM9.16667 13.3199C9.6196 13.3199 9.98677 12.9528 9.98677 12.4998C9.98677 12.0469 9.6196 11.6797 9.16667 11.6797V13.3199ZM2.5 8.3464C2.04707 8.3464 1.6799 8.71357 1.6799 9.1665C1.6799 9.61943 2.04707 9.98661 2.5 9.98661V8.3464ZM17.5 9.98661C17.9529 9.98661 18.3201 9.61943 18.3201 9.1665C18.3201 8.71357 17.9529 8.3464 17.5 8.3464V9.98661ZM2.5 6.67974C2.04707 6.67974 1.6799 7.04691 1.6799 7.49984C1.6799 7.95277 2.04707 8.31994 2.5 8.31994V6.67974ZM17.5 8.31994C17.9529 8.31994 18.3201 7.95277 18.3201 7.49984C18.3201 7.04691 17.9529 6.67974 17.5 6.67974V8.31994ZM16.6799 6.83313V13.1665H18.3201V6.83313H16.6799ZM14.8335 15.0131H5.16683V16.6533H14.8335V15.0131ZM3.3201 13.1665V6.83313H1.6799V13.1665H3.3201ZM5.16683 4.98661H14.8335V3.3464H5.16683V4.98661ZM3.3201 6.83313C3.3201 6.35289 3.32074 6.04204 3.34008 5.80528C3.35865 5.5781 3.39026 5.49224 3.41237 5.44886L1.95094 4.70422C1.79139 5.01735 1.73218 5.34308 1.70533 5.67171C1.67926 5.99076 1.6799 6.37995 1.6799 6.83313H3.3201ZM5.16683 3.3464C4.71364 3.3464 4.32437 3.34576 4.00523 3.37183C3.67657 3.39867 3.3507 3.45787 3.03751 3.61744L3.78215 5.07888C3.82548 5.0568 3.9114 5.02516 4.13875 5.00659C4.37563 4.98724 4.68659 4.98661 5.16683 4.98661V3.3464ZM3.41237 5.44886C3.49364 5.28935 3.62307 5.15993 3.78215 5.07888L3.03751 3.61744C2.56938 3.85597 2.18925 4.23652 1.95094 4.70422L3.41237 5.44886ZM5.16683 15.0131C4.68661 15.0131 4.37564 15.0124 4.13877 14.9931C3.91142 14.9745 3.82549 14.9429 3.78215 14.9208L3.03751 16.3822C3.35069 16.5418 3.67655 16.601 4.00521 16.6278C4.32435 16.6539 4.71363 16.6533 5.16683 16.6533V15.0131ZM1.6799 13.1665C1.6799 13.6196 1.67926 14.0089 1.70533 14.3279C1.73218 14.6566 1.79138 14.9824 1.95094 15.2955L3.41237 14.5509C3.39027 14.5075 3.35865 14.4216 3.34009 14.1944C3.32074 13.9576 3.3201 13.6467 3.3201 13.1665H1.6799ZM3.78215 14.9208C3.62298 14.8397 3.4936 14.7103 3.41237 14.5509L1.95094 15.2955C2.18929 15.7633 2.56947 16.1437 3.03751 16.3822L3.78215 14.9208ZM16.6799 13.1665C16.6799 13.6468 16.6793 13.9577 16.66 14.1945C16.6415 14.4218 16.6099 14.5076 16.5878 14.5509L18.0492 15.2955C18.2088 14.9823 18.268 14.6564 18.2948 14.3278C18.3208 14.0088 18.3201 13.6196 18.3201 13.1665H16.6799ZM14.8335 16.6533C15.2867 16.6533 15.6758 16.6539 15.9948 16.6278C16.3234 16.601 16.6491 16.5417 16.9621 16.3822L16.2175 14.9208C16.1741 14.9429 16.0882 14.9745 15.8612 14.9931C15.6245 15.0124 15.3137 15.0131 14.8335 15.0131V16.6533ZM16.5878 14.5509C16.5069 14.7097 16.3772 14.8394 16.2175 14.9208L16.9621 16.3822C17.4296 16.144 17.8106 15.7639 18.0492 15.2955L16.5878 14.5509ZM18.3201 6.83313C18.3201 6.38004 18.3208 5.99084 18.2948 5.67184C18.268 5.34325 18.2088 5.01744 18.0492 4.70422L16.5878 5.44886C16.6099 5.49215 16.6415 5.57793 16.66 5.80515C16.6793 6.04197 16.6799 6.3528 16.6799 6.83313H18.3201ZM14.8335 4.98661C15.3137 4.98661 15.6245 4.98724 15.8612 5.00659C16.0883 5.02514 16.1741 5.05675 16.2175 5.07888L16.9621 3.61744C16.649 3.45791 16.3234 3.39869 15.9948 3.37183C15.6758 3.34576 15.2867 3.3464 14.8335 3.3464V4.98661ZM18.0492 4.70422C17.8107 4.23597 17.4297 3.85569 16.9621 3.61744L16.2175 5.07888C16.3771 5.16021 16.5068 5.2899 16.5878 5.44886L18.0492 4.70422ZM5.83333 13.3199H9.16667V11.6797H5.83333V13.3199ZM2.5 9.98661H17.5V8.3464H2.5V9.98661ZM2.5 8.31994H17.5V6.67974H2.5V8.31994Z"
                        fill="white"
                      />
                    </svg>
                  }
                  color="#88C02C"
                />

                <SinglePanel
                  description="Save and Pack Total Amount"
                  amount={` ${cooperativeStat.saveAndPackTotalAmount}`}
                  isValue={false}
                  icon={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.68166 5.07654L3.41237 5.44886L2.68166 5.07654ZM3.40983 4.34816L3.78215 5.07888L3.40983 4.34816ZM3.40983 15.6515L3.78215 14.9208L3.40983 15.6515ZM2.68166 14.9232L1.95094 15.2955L2.68166 14.9232ZM17.3185 14.9232L16.5878 14.5509L17.3185 14.9232ZM16.5898 15.6515L16.2175 14.9208L16.5898 15.6515ZM17.3185 5.07654L16.5878 5.44886V5.44886L17.3185 5.07654ZM16.5898 4.34816L16.9621 3.61744L16.5898 4.34816ZM5.83333 11.6797C5.3804 11.6797 5.01323 12.0469 5.01323 12.4998C5.01323 12.9528 5.3804 13.3199 5.83333 13.3199V11.6797ZM9.16667 13.3199C9.6196 13.3199 9.98677 12.9528 9.98677 12.4998C9.98677 12.0469 9.6196 11.6797 9.16667 11.6797V13.3199ZM2.5 8.3464C2.04707 8.3464 1.6799 8.71357 1.6799 9.1665C1.6799 9.61943 2.04707 9.98661 2.5 9.98661V8.3464ZM17.5 9.98661C17.9529 9.98661 18.3201 9.61943 18.3201 9.1665C18.3201 8.71357 17.9529 8.3464 17.5 8.3464V9.98661ZM2.5 6.67974C2.04707 6.67974 1.6799 7.04691 1.6799 7.49984C1.6799 7.95277 2.04707 8.31994 2.5 8.31994V6.67974ZM17.5 8.31994C17.9529 8.31994 18.3201 7.95277 18.3201 7.49984C18.3201 7.04691 17.9529 6.67974 17.5 6.67974V8.31994ZM16.6799 6.83313V13.1665H18.3201V6.83313H16.6799ZM14.8335 15.0131H5.16683V16.6533H14.8335V15.0131ZM3.3201 13.1665V6.83313H1.6799V13.1665H3.3201ZM5.16683 4.98661H14.8335V3.3464H5.16683V4.98661ZM3.3201 6.83313C3.3201 6.35289 3.32074 6.04204 3.34008 5.80528C3.35865 5.5781 3.39026 5.49224 3.41237 5.44886L1.95094 4.70422C1.79139 5.01735 1.73218 5.34308 1.70533 5.67171C1.67926 5.99076 1.6799 6.37995 1.6799 6.83313H3.3201ZM5.16683 3.3464C4.71364 3.3464 4.32437 3.34576 4.00523 3.37183C3.67657 3.39867 3.3507 3.45787 3.03751 3.61744L3.78215 5.07888C3.82548 5.0568 3.9114 5.02516 4.13875 5.00659C4.37563 4.98724 4.68659 4.98661 5.16683 4.98661V3.3464ZM3.41237 5.44886C3.49364 5.28935 3.62307 5.15993 3.78215 5.07888L3.03751 3.61744C2.56938 3.85597 2.18925 4.23652 1.95094 4.70422L3.41237 5.44886ZM5.16683 15.0131C4.68661 15.0131 4.37564 15.0124 4.13877 14.9931C3.91142 14.9745 3.82549 14.9429 3.78215 14.9208L3.03751 16.3822C3.35069 16.5418 3.67655 16.601 4.00521 16.6278C4.32435 16.6539 4.71363 16.6533 5.16683 16.6533V15.0131ZM1.6799 13.1665C1.6799 13.6196 1.67926 14.0089 1.70533 14.3279C1.73218 14.6566 1.79138 14.9824 1.95094 15.2955L3.41237 14.5509C3.39027 14.5075 3.35865 14.4216 3.34009 14.1944C3.32074 13.9576 3.3201 13.6467 3.3201 13.1665H1.6799ZM3.78215 14.9208C3.62298 14.8397 3.4936 14.7103 3.41237 14.5509L1.95094 15.2955C2.18929 15.7633 2.56947 16.1437 3.03751 16.3822L3.78215 14.9208ZM16.6799 13.1665C16.6799 13.6468 16.6793 13.9577 16.66 14.1945C16.6415 14.4218 16.6099 14.5076 16.5878 14.5509L18.0492 15.2955C18.2088 14.9823 18.268 14.6564 18.2948 14.3278C18.3208 14.0088 18.3201 13.6196 18.3201 13.1665H16.6799ZM14.8335 16.6533C15.2867 16.6533 15.6758 16.6539 15.9948 16.6278C16.3234 16.601 16.6491 16.5417 16.9621 16.3822L16.2175 14.9208C16.1741 14.9429 16.0882 14.9745 15.8612 14.9931C15.6245 15.0124 15.3137 15.0131 14.8335 15.0131V16.6533ZM16.5878 14.5509C16.5069 14.7097 16.3772 14.8394 16.2175 14.9208L16.9621 16.3822C17.4296 16.144 17.8106 15.7639 18.0492 15.2955L16.5878 14.5509ZM18.3201 6.83313C18.3201 6.38004 18.3208 5.99084 18.2948 5.67184C18.268 5.34325 18.2088 5.01744 18.0492 4.70422L16.5878 5.44886C16.6099 5.49215 16.6415 5.57793 16.66 5.80515C16.6793 6.04197 16.6799 6.3528 16.6799 6.83313H18.3201ZM14.8335 4.98661C15.3137 4.98661 15.6245 4.98724 15.8612 5.00659C16.0883 5.02514 16.1741 5.05675 16.2175 5.07888L16.9621 3.61744C16.649 3.45791 16.3234 3.39869 15.9948 3.37183C15.6758 3.34576 15.2867 3.3464 14.8335 3.3464V4.98661ZM18.0492 4.70422C17.8107 4.23597 17.4297 3.85569 16.9621 3.61744L16.2175 5.07888C16.3771 5.16021 16.5068 5.2899 16.5878 5.44886L18.0492 4.70422ZM5.83333 13.3199H9.16667V11.6797H5.83333V13.3199ZM2.5 9.98661H17.5V8.3464H2.5V9.98661ZM2.5 8.31994H17.5V6.67974H2.5V8.31994Z"
                        fill="white"
                      />
                    </svg>
                  }
                  color="#88C02C"
                />
                <SinglePanel
                  description="Total Loan Requested"
                  amount={` ${loanStat.totalLoanRequestAmount}`}
                  isValue={false}
                  icon={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.68166 5.07654L3.41237 5.44886L2.68166 5.07654ZM3.40983 4.34816L3.78215 5.07888L3.40983 4.34816ZM3.40983 15.6515L3.78215 14.9208L3.40983 15.6515ZM2.68166 14.9232L1.95094 15.2955L2.68166 14.9232ZM17.3185 14.9232L16.5878 14.5509L17.3185 14.9232ZM16.5898 15.6515L16.2175 14.9208L16.5898 15.6515ZM17.3185 5.07654L16.5878 5.44886V5.44886L17.3185 5.07654ZM16.5898 4.34816L16.9621 3.61744L16.5898 4.34816ZM5.83333 11.6797C5.3804 11.6797 5.01323 12.0469 5.01323 12.4998C5.01323 12.9528 5.3804 13.3199 5.83333 13.3199V11.6797ZM9.16667 13.3199C9.6196 13.3199 9.98677 12.9528 9.98677 12.4998C9.98677 12.0469 9.6196 11.6797 9.16667 11.6797V13.3199ZM2.5 8.3464C2.04707 8.3464 1.6799 8.71357 1.6799 9.1665C1.6799 9.61943 2.04707 9.98661 2.5 9.98661V8.3464ZM17.5 9.98661C17.9529 9.98661 18.3201 9.61943 18.3201 9.1665C18.3201 8.71357 17.9529 8.3464 17.5 8.3464V9.98661ZM2.5 6.67974C2.04707 6.67974 1.6799 7.04691 1.6799 7.49984C1.6799 7.95277 2.04707 8.31994 2.5 8.31994V6.67974ZM17.5 8.31994C17.9529 8.31994 18.3201 7.95277 18.3201 7.49984C18.3201 7.04691 17.9529 6.67974 17.5 6.67974V8.31994ZM16.6799 6.83313V13.1665H18.3201V6.83313H16.6799ZM14.8335 15.0131H5.16683V16.6533H14.8335V15.0131ZM3.3201 13.1665V6.83313H1.6799V13.1665H3.3201ZM5.16683 4.98661H14.8335V3.3464H5.16683V4.98661ZM3.3201 6.83313C3.3201 6.35289 3.32074 6.04204 3.34008 5.80528C3.35865 5.5781 3.39026 5.49224 3.41237 5.44886L1.95094 4.70422C1.79139 5.01735 1.73218 5.34308 1.70533 5.67171C1.67926 5.99076 1.6799 6.37995 1.6799 6.83313H3.3201ZM5.16683 3.3464C4.71364 3.3464 4.32437 3.34576 4.00523 3.37183C3.67657 3.39867 3.3507 3.45787 3.03751 3.61744L3.78215 5.07888C3.82548 5.0568 3.9114 5.02516 4.13875 5.00659C4.37563 4.98724 4.68659 4.98661 5.16683 4.98661V3.3464ZM3.41237 5.44886C3.49364 5.28935 3.62307 5.15993 3.78215 5.07888L3.03751 3.61744C2.56938 3.85597 2.18925 4.23652 1.95094 4.70422L3.41237 5.44886ZM5.16683 15.0131C4.68661 15.0131 4.37564 15.0124 4.13877 14.9931C3.91142 14.9745 3.82549 14.9429 3.78215 14.9208L3.03751 16.3822C3.35069 16.5418 3.67655 16.601 4.00521 16.6278C4.32435 16.6539 4.71363 16.6533 5.16683 16.6533V15.0131ZM1.6799 13.1665C1.6799 13.6196 1.67926 14.0089 1.70533 14.3279C1.73218 14.6566 1.79138 14.9824 1.95094 15.2955L3.41237 14.5509C3.39027 14.5075 3.35865 14.4216 3.34009 14.1944C3.32074 13.9576 3.3201 13.6467 3.3201 13.1665H1.6799ZM3.78215 14.9208C3.62298 14.8397 3.4936 14.7103 3.41237 14.5509L1.95094 15.2955C2.18929 15.7633 2.56947 16.1437 3.03751 16.3822L3.78215 14.9208ZM16.6799 13.1665C16.6799 13.6468 16.6793 13.9577 16.66 14.1945C16.6415 14.4218 16.6099 14.5076 16.5878 14.5509L18.0492 15.2955C18.2088 14.9823 18.268 14.6564 18.2948 14.3278C18.3208 14.0088 18.3201 13.6196 18.3201 13.1665H16.6799ZM14.8335 16.6533C15.2867 16.6533 15.6758 16.6539 15.9948 16.6278C16.3234 16.601 16.6491 16.5417 16.9621 16.3822L16.2175 14.9208C16.1741 14.9429 16.0882 14.9745 15.8612 14.9931C15.6245 15.0124 15.3137 15.0131 14.8335 15.0131V16.6533ZM16.5878 14.5509C16.5069 14.7097 16.3772 14.8394 16.2175 14.9208L16.9621 16.3822C17.4296 16.144 17.8106 15.7639 18.0492 15.2955L16.5878 14.5509ZM18.3201 6.83313C18.3201 6.38004 18.3208 5.99084 18.2948 5.67184C18.268 5.34325 18.2088 5.01744 18.0492 4.70422L16.5878 5.44886C16.6099 5.49215 16.6415 5.57793 16.66 5.80515C16.6793 6.04197 16.6799 6.3528 16.6799 6.83313H18.3201ZM14.8335 4.98661C15.3137 4.98661 15.6245 4.98724 15.8612 5.00659C16.0883 5.02514 16.1741 5.05675 16.2175 5.07888L16.9621 3.61744C16.649 3.45791 16.3234 3.39869 15.9948 3.37183C15.6758 3.34576 15.2867 3.3464 14.8335 3.3464V4.98661ZM18.0492 4.70422C17.8107 4.23597 17.4297 3.85569 16.9621 3.61744L16.2175 5.07888C16.3771 5.16021 16.5068 5.2899 16.5878 5.44886L18.0492 4.70422ZM5.83333 13.3199H9.16667V11.6797H5.83333V13.3199ZM2.5 9.98661H17.5V8.3464H2.5V9.98661ZM2.5 8.31994H17.5V6.67974H2.5V8.31994Z"
                        fill="white"
                      />
                    </svg>
                  }
                  color="#88C02C"
                />
                <SinglePanel
                  description="Total Disbursed loan"
                  value={loanStat?.totalDisbursedAmount}
                  isValue={false}
                  icon={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.1667 16.6665C14.1667 15.2858 12.3012 14.1665 10 14.1665C7.69881 14.1665 5.83333 15.2858 5.83333 16.6665M17.5 14.1664C17.5 13.1412 16.4716 12.2602 15 11.8744M2.5 14.1664C2.5 13.1412 3.52841 12.2602 5 11.8744M15 8.52993C15.5115 8.07216 15.8333 7.40692 15.8333 6.6665C15.8333 5.28579 14.714 4.1665 13.3333 4.1665C12.693 4.1665 12.109 4.40722 11.6667 4.80308M5 8.52993C4.48854 8.07216 4.16667 7.40692 4.16667 6.6665C4.16667 5.28579 5.28595 4.1665 6.66667 4.1665C7.30696 4.1665 7.89104 4.40722 8.33333 4.80308M10 11.6665C8.61929 11.6665 7.5 10.5472 7.5 9.1665C7.5 7.78579 8.61929 6.6665 10 6.6665C11.3807 6.6665 12.5 7.78579 12.5 9.1665C12.5 10.5472 11.3807 11.6665 10 11.6665Z"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  color="#F59E0B"
                />
                <SinglePanel
                  description="Total Repaid Loans"
                  value={loanStat?.totalRepaidAmount}
                  isValue={false}
                  icon={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.1667 16.6665C14.1667 15.2858 12.3012 14.1665 10 14.1665C7.69881 14.1665 5.83333 15.2858 5.83333 16.6665M17.5 14.1664C17.5 13.1412 16.4716 12.2602 15 11.8744M2.5 14.1664C2.5 13.1412 3.52841 12.2602 5 11.8744M15 8.52993C15.5115 8.07216 15.8333 7.40692 15.8333 6.6665C15.8333 5.28579 14.714 4.1665 13.3333 4.1665C12.693 4.1665 12.109 4.40722 11.6667 4.80308M5 8.52993C4.48854 8.07216 4.16667 7.40692 4.16667 6.6665C4.16667 5.28579 5.28595 4.1665 6.66667 4.1665C7.30696 4.1665 7.89104 4.40722 8.33333 4.80308M10 11.6665C8.61929 11.6665 7.5 10.5472 7.5 9.1665C7.5 7.78579 8.61929 6.6665 10 6.6665C11.3807 6.6665 12.5 7.78579 12.5 9.1665C12.5 10.5472 11.3807 11.6665 10 11.6665Z"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  color="#F59E0B"
                />

                <SinglePanel
                  description="Total Loan Profit"
                  value={` ${loanStat?.profit}`}
                  isValue={false}
                  icon={
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.68166 5.07654L3.41237 5.44886L2.68166 5.07654ZM3.40983 4.34816L3.78215 5.07888L3.40983 4.34816ZM3.40983 15.6515L3.78215 14.9208L3.40983 15.6515ZM2.68166 14.9232L1.95094 15.2955L2.68166 14.9232ZM17.3185 14.9232L16.5878 14.5509L17.3185 14.9232ZM16.5898 15.6515L16.2175 14.9208L16.5898 15.6515ZM17.3185 5.07654L16.5878 5.44886V5.44886L17.3185 5.07654ZM16.5898 4.34816L16.9621 3.61744L16.5898 4.34816ZM5.83333 11.6797C5.3804 11.6797 5.01323 12.0469 5.01323 12.4998C5.01323 12.9528 5.3804 13.3199 5.83333 13.3199V11.6797ZM9.16667 13.3199C9.6196 13.3199 9.98677 12.9528 9.98677 12.4998C9.98677 12.0469 9.6196 11.6797 9.16667 11.6797V13.3199ZM2.5 8.3464C2.04707 8.3464 1.6799 8.71357 1.6799 9.1665C1.6799 9.61943 2.04707 9.98661 2.5 9.98661V8.3464ZM17.5 9.98661C17.9529 9.98661 18.3201 9.61943 18.3201 9.1665C18.3201 8.71357 17.9529 8.3464 17.5 8.3464V9.98661ZM2.5 6.67974C2.04707 6.67974 1.6799 7.04691 1.6799 7.49984C1.6799 7.95277 2.04707 8.31994 2.5 8.31994V6.67974ZM17.5 8.31994C17.9529 8.31994 18.3201 7.95277 18.3201 7.49984C18.3201 7.04691 17.9529 6.67974 17.5 6.67974V8.31994ZM16.6799 6.83313V13.1665H18.3201V6.83313H16.6799ZM14.8335 15.0131H5.16683V16.6533H14.8335V15.0131ZM3.3201 13.1665V6.83313H1.6799V13.1665H3.3201ZM5.16683 4.98661H14.8335V3.3464H5.16683V4.98661ZM3.3201 6.83313C3.3201 6.35289 3.32074 6.04204 3.34008 5.80528C3.35865 5.5781 3.39026 5.49224 3.41237 5.44886L1.95094 4.70422C1.79139 5.01735 1.73218 5.34308 1.70533 5.67171C1.67926 5.99076 1.6799 6.37995 1.6799 6.83313H3.3201ZM5.16683 3.3464C4.71364 3.3464 4.32437 3.34576 4.00523 3.37183C3.67657 3.39867 3.3507 3.45787 3.03751 3.61744L3.78215 5.07888C3.82548 5.0568 3.9114 5.02516 4.13875 5.00659C4.37563 4.98724 4.68659 4.98661 5.16683 4.98661V3.3464ZM3.41237 5.44886C3.49364 5.28935 3.62307 5.15993 3.78215 5.07888L3.03751 3.61744C2.56938 3.85597 2.18925 4.23652 1.95094 4.70422L3.41237 5.44886ZM5.16683 15.0131C4.68661 15.0131 4.37564 15.0124 4.13877 14.9931C3.91142 14.9745 3.82549 14.9429 3.78215 14.9208L3.03751 16.3822C3.35069 16.5418 3.67655 16.601 4.00521 16.6278C4.32435 16.6539 4.71363 16.6533 5.16683 16.6533V15.0131ZM1.6799 13.1665C1.6799 13.6196 1.67926 14.0089 1.70533 14.3279C1.73218 14.6566 1.79138 14.9824 1.95094 15.2955L3.41237 14.5509C3.39027 14.5075 3.35865 14.4216 3.34009 14.1944C3.32074 13.9576 3.3201 13.6467 3.3201 13.1665H1.6799ZM3.78215 14.9208C3.62298 14.8397 3.4936 14.7103 3.41237 14.5509L1.95094 15.2955C2.18929 15.7633 2.56947 16.1437 3.03751 16.3822L3.78215 14.9208ZM16.6799 13.1665C16.6799 13.6468 16.6793 13.9577 16.66 14.1945C16.6415 14.4218 16.6099 14.5076 16.5878 14.5509L18.0492 15.2955C18.2088 14.9823 18.268 14.6564 18.2948 14.3278C18.3208 14.0088 18.3201 13.6196 18.3201 13.1665H16.6799ZM14.8335 16.6533C15.2867 16.6533 15.6758 16.6539 15.9948 16.6278C16.3234 16.601 16.6491 16.5417 16.9621 16.3822L16.2175 14.9208C16.1741 14.9429 16.0882 14.9745 15.8612 14.9931C15.6245 15.0124 15.3137 15.0131 14.8335 15.0131V16.6533ZM16.5878 14.5509C16.5069 14.7097 16.3772 14.8394 16.2175 14.9208L16.9621 16.3822C17.4296 16.144 17.8106 15.7639 18.0492 15.2955L16.5878 14.5509ZM18.3201 6.83313C18.3201 6.38004 18.3208 5.99084 18.2948 5.67184C18.268 5.34325 18.2088 5.01744 18.0492 4.70422L16.5878 5.44886C16.6099 5.49215 16.6415 5.57793 16.66 5.80515C16.6793 6.04197 16.6799 6.3528 16.6799 6.83313H18.3201ZM14.8335 4.98661C15.3137 4.98661 15.6245 4.98724 15.8612 5.00659C16.0883 5.02514 16.1741 5.05675 16.2175 5.07888L16.9621 3.61744C16.649 3.45791 16.3234 3.39869 15.9948 3.37183C15.6758 3.34576 15.2867 3.3464 14.8335 3.3464V4.98661ZM18.0492 4.70422C17.8107 4.23597 17.4297 3.85569 16.9621 3.61744L16.2175 5.07888C16.3771 5.16021 16.5068 5.2899 16.5878 5.44886L18.0492 4.70422ZM5.83333 13.3199H9.16667V11.6797H5.83333V13.3199ZM2.5 9.98661H17.5V8.3464H2.5V9.98661ZM2.5 8.31994H17.5V6.67974H2.5V8.31994Z"
                        fill="white"
                      />
                    </svg>
                  }
                  color="#88C02C"
                />
              </div>
            );
          }}
        </Await>
      </Suspense>
      <div className="grid w-full grid-cols-1 gap-5 md:grid-cols-7">
        <Panel className="md:col-span-3">
          <TotalRequest />
        </Panel>
        <Panel className="md:col-span-4">
          <TransactionSummary />
        </Panel>
      </div>

      <div className="grid w-full grid-cols-3 gap-5">
        <Panel className="col-span-2">
          <DailyRequest />
        </Panel>
        <Panel>
          <PendingRequest />
        </Panel>
      </div>
      <div>
        <CapsaTransaction />
      </div>
      <div className="w-full">
        <LoanTable/>
        <LoanProfitTable/>
      </div>
    </div>
  );
};

const Panel = ({ className, children }) => {
  return (
    <div className={`rounded-[24px] bg-white p-6 shadow-sm ${className}`}>
      {children}
    </div>
  );
};

const SinglePanel = ({
  value = 0,
  amount = 0,
  description = "",
  icon = "",
  isValue = false,
  color,
}) => {
  return (
    <div className="relative flex h-[100px] w-full flex-wrap items-center justify-start p-4">
      <div>
        <h3 className="font-bold leading-[30px] tracking-wide text-gray-900">
          {isValue
            ? new Intl.NumberFormat("en-US").format(value)
            : new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "NGN",
              }).format(amount)}
        </h3>
        <p className="text-sm text-gray-500">{description}</p>
      </div>
      <span
        className="absolute -top-2 right-4 inline-flex h-8 w-8 items-center justify-center rounded-full p-1 text-white"
        style={{ backgroundColor: color }}
      >
        {icon}
      </span>
    </div>
  );
};

const TransactionSummary = () => {
  const data = useLoaderData();

  return (
    <Suspense>
      <Await resolve={data?.data}>
        {(data) => {
          const load = data.response?.data?.transaction_breakdown ?? {};
          const colors = [
            "#FF6384",
            "#FF9F40",
            "#FFCD56",
            "#4BC0C0",
            "#36A2EB",
          ];
          const label = ["paid", "pending", "advanced", "declined"];
          const dataset = Object.values(load);
          return (
            <div className="grid grid-cols-2">
              <div>
                <h3 className="text-[20px] font-[700] leading-[30px] tracking-wide text-gray-900">
                  Transaction Summary
                </h3>
                <Doughnut
                  id="transaction-summary"
                  data={{
                    labels: label,
                    datasets: [
                      {
                        label: "Transaction Summary",
                        data: dataset,
                        backgroundColor: colors,
                      },
                    ],
                    borderWidth: 1,
                  }}
                />
              </div>
              <ul className="flex flex-col items-start justify-center space-y-5 p-6">
                {dataset.map((amount, index) => (
                  <li
                    className="flex items-start justify-start space-x-4"
                    key={index}
                  >
                    <div
                      className="mt-2 inline-block h-4 w-4 rounded-full"
                      style={{ backgroundColor: colors[index] }}
                    ></div>
                    <div>
                      <p className="text-[20px] font-[700] leading-[30px] tracking-wide text-gray-900">
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "NGN",
                        }).format(amount)}
                      </p>
                      <p className="text-[14px] font-[400] capitalize leading-[21px] text-gray-500">
                        {label[index]}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          );
        }}
      </Await>
    </Suspense>
  );
};
const CapsaTransaction = () => {
  const data = useLoaderData();
  const PAGE_SIZE = 10; // Number of items per page

  const [itemPerPage, setItemPerPage] = useState(10);

  function formatAmount(amount) {
    if (typeof amount === "string") {
      amount = parseFloat(amount);
    }
    return amount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const handleLoadMore = () => {
    setItemPerPage((prevPage) => prevPage + PAGE_SIZE);
  };

  return (
    <Suspense>
      <Await resolve={data?.data}>
        {(data) => {
          const capsa = data?.capsaData?.data ?? [];
          const invoicesArray = JSON.parse(capsa?.invoices);

          // const startIndex = (currentPage - 1) * PAGE_SIZE;
          // const endIndex = startIndex + PAGE_SIZE;
          const visibleInvoices = invoicesArray.slice(0, itemPerPage);
          return (
            <div className="flex w-full flex-col space-y-6 rounded-lg bg-white p-4">
              <div className="h-[600px] w-full overflow-x-scroll overflow-y-scroll">
                <h2 className="mb-4 text-2xl font-semibold">Invoices</h2>
                {visibleInvoices.length > 0 ? (
                  <table className="w-full table-auto overflow-scroll">
                    <thead className="">
                      <tr className="h-14 rounded-md bg-[#5b3192] text-left text-[14px] font-[700] leading-[14px] text-white">
                        <th
                          className={`whitespace-nowrap px-[25.5px] py-[17.5px]`}
                        >
                          Company Name
                        </th>
                        <th
                          className={`whitespace-nowrap px-[25.5px] py-[17.5px]`}
                        >
                          Customer Name
                        </th>
                        <th
                          className={`whitespace-nowrap px-[25.5px] py-[17.5px]`}
                        >
                          Amount Paid
                        </th>
                        <th
                          className={`whitespace-nowrap px-[25.5px] py-[17.5px]`}
                        >
                          Amount Received
                        </th>
                        <th
                          className={`whitespace-nowrap px-[25.5px] py-[17.5px]`}
                        >
                          Total After Capsa Fees
                        </th>
                        <th
                          className={`whitespace-nowrap px-[25.5px] py-[17.5px]`}
                        >
                          Base Discount Rate
                        </th>
                        <th
                          className={`whitespace-nowrap px-[25.5px] py-[17.5px]`}
                        >
                          Annualized Rate
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {visibleInvoices.map((invoice, index) => (
                        <tr
                          key={index}
                          className="rounded-[8px] bg-[#f7f8f9] text-left text-[14px] font-[700] leading-[14px] text-[#0d0f11]"
                        >
                          <td className="whitespace-normal px-[25.5px] py-[17.5px] font-[500]">
                            {invoice.company_name}
                          </td>
                          <td className="whitespace-normal px-[25.5px] py-[17.5px] font-[500]">
                            {invoice.customer_name}
                          </td>
                          <td className="whitespace-normal px-[25.5px] py-[17.5px] font-[500]">
                            &#8358;{formatAmount(invoice.amount_paid)}
                          </td>
                          <td className="whitespace-normal px-[25.5px] py-[17.5px] font-[500]">
                            &#8358;{formatAmount(invoice.amount_received)}
                          </td>
                          <td className="whitespace-normal px-[25.5px] py-[17.5px] font-[500]">
                            &#8358;
                            {formatAmount(invoice.total_after_capsa_fees)}
                          </td>
                          <td className="whitespace-normal px-[25.5px] py-[17.5px] font-[500]">
                            {invoice.base_discount_rate}%
                          </td>
                          <td className="whitespace-normal px-[25.5px] py-[17.5px] font-[500]">
                            {invoice.annualized_rate}%
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No invoices found.</p>
                )}

                {invoicesArray.length > itemPerPage && (
                  <button
                    onClick={handleLoadMore}
                    className="text- w-full rounded-md bg-fedacash-header px-2 py-2 text-center"
                  >
                    Load More
                  </button>
                )}
              </div>
            </div>
          );
        }}
      </Await>
    </Suspense>
  );
};
const TotalRequest = () => {
  const data = useLoaderData();

  return (
    <Suspense>
      <Await resolve={data?.data}>
        {(data) => {
          const request_breakdown =
            data?.response?.data?.request_breakdown ?? {};
          const calc = (value) => {
            if (Number(value) === 0) {
              return 0;
            }
            return (value / request_breakdown?.total) * 100;
          };
          return (
            <div className="flex w-full flex-col items-start justify-start">
              <div className="flex w-full flex-none items-center justify-between">
                <h3 className="text-[20px] font-[700] leading-[30px] tracking-wide text-gray-900">
                  Total Request
                </h3>
                <span className="text-[14px] font-[400] leading-[21px] text-gray-500">
                  {request_breakdown?.total}
                </span>
              </div>
              <div className="h-full w-full flex-grow py-10">
                <ul className="flex h-full flex-col items-start justify-between space-y-8 text-[14px] font-[400] leading-[21px] text-gray-500">
                  <li className="inline-block w-full">
                    <div className="mb-1 flex items-center justify-between">
                      <span>Paid Request</span>
                      <span>{request_breakdown?.paid}</span>
                    </div>
                    <span className="inline-flex h-[12px] w-full overflow-hidden rounded-full border bg-gray-100">
                      <span
                        className="inline-block h-full bg-[#88C02C]"
                        style={{
                          width: calc(request_breakdown?.paid) + "%",
                        }}
                      ></span>
                    </span>
                  </li>
                  <li className="inline-block w-full">
                    <div className="mb-1 flex items-center justify-between">
                      <span>Advanced Request</span>
                      <span>{request_breakdown?.advanced}</span>
                    </div>
                    <span className="inline-flex h-[12px] w-full overflow-hidden rounded-full border bg-gray-100">
                      <span
                        className="inline-block h-full bg-[#610BEF]"
                        style={{
                          width: calc(request_breakdown?.advanced) + "%",
                        }}
                      ></span>
                    </span>
                  </li>
                  <li className="inline-block w-full">
                    <div className="mb-1 flex items-center justify-between">
                      <span>Pending Request</span>
                      <span>{request_breakdown.pending}</span>
                    </div>
                    <span className="inline-flex h-[12px] w-full overflow-hidden rounded-full border bg-gray-100">
                      <span
                        className="inline-block h-full bg-[#03CFBB]"
                        style={{
                          width: calc(request_breakdown?.pending) + "%",
                        }}
                      ></span>
                    </span>
                  </li>
                  <li className="inline-block w-full">
                    <div className="mb-1 flex items-center justify-between">
                      <span>Rejected Request</span>
                      <span>{request_breakdown.declined}</span>
                    </div>
                    <span className="inline-flex h-[12px] w-full overflow-hidden rounded-full border bg-gray-100">
                      <span
                        className="inline-block h-full bg-[#F59E0B]"
                        style={{
                          width: calc(request_breakdown.declined) + "%",
                        }}
                      ></span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          );
        }}
      </Await>
    </Suspense>
  );
};

const PendingRequest = () => {
  const load = useLoaderData();
  return (
    <Suspense>
      <Await resolve={load?.data}>
        {(d) => {
          const pendingData = d?.response?.data?.pending_requests;
          return (
            <div>
              <div className="flex items-center justify-between">
                <span className="text-[20px] font-[700] leading-[30px] tracking-wide text-gray-900">
                  Pending Request
                </span>
                <Link
                  to="transactions"
                  className="text-[14px] font-[400] leading-[21px] text-[#590DA4] underline "
                >
                  View All
                </Link>
              </div>
              <div>
                <table className="w-full text-left">
                  <thead className="overflow-hidden rounded-2xl">
                    <tr className="rounded-2xl bg-[#F7F8F9]">
                      <th className="px-[27px] py-[13px] text-left">
                        Customer
                      </th>
                      <th className="px-[27px] py-[13px] text-left">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pendingData?.map((item, index) => (
                      <tr key={index} className="border-b last:border-none">
                        <td className="px-[27px] py-[13px]">
                          {item.organization?.name}
                        </td>
                        <td className="px-[27px] py-[13px]">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "NGN",
                          }).format(item.amount)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          );
        }}
      </Await>
    </Suspense>
  );
};

const DailyRequest = () => {
  const load = useLoaderData();
  const [state, setState] = useState("day");

  return (
    <Suspense>
      <Await resolve={load?.data}>
        {(data) => {
          const request_chart = data?.response?.data?.request_chart ?? {};
          const labels = request_chart[state]?.label;

          const dt = {
            labels: labels,
            datasets: [
              {
                label: (state === "day" ? "Daily" : "Monthly") + " Request",
                data: request_chart[state]?.data,
                borderColor: "#590DA4",
                backgroundColor: "#590DA4",
              },
            ],
          };
          return (
            <div>
              <div className="flex items-center justify-between">
                <span>{state === "day" ? "Daily" : "Monthly"} Request</span>
                <span className="inline-flex space-x-2 overflow-hidden ">
                  <button
                    data-active={state === "day"}
                    className="rounded-full border border-gray-300 px-4 py-2 hover:bg-gray-200 data-[active=true]:bg-gray-300"
                    onClick={() => {
                      setState("day");
                    }}
                  >
                    Day
                  </button>
                  <button
                    data-active={state === "month"}
                    className="rounded-full border border-gray-300 px-4 py-2 hover:bg-gray-200 data-[active=true]:bg-gray-300"
                    onClick={() => {
                      setState("month");
                    }}
                  >
                    Month
                  </button>
                </span>
              </div>
              <Line about="Daily Request" data={dt} id="daily-request" />
            </div>
          );
        }}
      </Await>
    </Suspense>
  );
};

export default DashboardIndex;
